import styled, { keyframes } from "styled-components";

import { colors } from "src/assets/styles/settings";

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const SpinnerLineStyled = styled.div`
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 3px;
  position: relative;
  border-top: 3px solid rgba(0, 0, 0, 0.25);
  border-right: 3px solid rgba(0, 0, 0, 0.25);
  border-bottom: 3px solid rgba(0, 0, 0, 0.25);
  border-left: 3px solid ${colors.black_bekko};
  transform: translateZ(0);
  animation: ${spin} 0.8s infinite linear;
  margin-right: 16px;

  &::after {
    border-radius: 50%;
    width: 20px;
    height: 20px;
  }
`;
